/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusIcon20Light = forwardRef('PlusIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 1.917a.5.5 0 0 1 .5.5V9h6.583a.5.5 0 1 1 0 1H10v6.584a.5.5 0 1 1-1 0V10H2.417a.5.5 0 0 1 0-1H9V2.417a.5.5 0 0 1 .5-.5Z" })));
});
